<template>
	<section class="gallery">
		<svg
			class="svg"
			width="0"
			height="0"
			:viewBox="`0 0 ${pathWidth} ${pathHeight}`"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<defs>
				<clipPath id="my-shape">
					<path :d="d">
						<animate attributeName="d" v-if="d" :values="`${d};${d2};${d}`" dur="4s" repeatCount="indefinite" />
					</path>
				</clipPath>
			</defs>
		</svg>
		<div class="images" ref="images" v-hammer:swipe.horizontal="swipeHandler">
			<transition-group name="list">
				<svg
					class="svg"
					:width="pathWidth"
					:height="pathHeight"
					:viewBox="`0 0 ${pathWidth} ${pathHeight}`"
					v-show="i === current"
					version="1.1"
					v-for="(image, i) in images"
					:key="`img_${i}`"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
				>
					<defs>
						<clipPath id="my-shape">
							<path :d="d">
								<animate attributeName="d" v-if="d" :values="`${d};${d2};${d}`" dur="4s" repeatCount="indefinite" />
							</path>
						</clipPath>
					</defs>
					<g clip-path="url(#my-shape)">
						<image width="100%" :href="image.url" />
					</g>
				</svg>
				<!-- <img v-for="(image, i) in images" :key="`img_${i}`" :src="image.url"  /> -->
			</transition-group>
		</div>

		<ul class="nav">
			<li
				v-for="(n, i) in images"
				:key="`nav_${i}`"
				@click="setSlide(i)"
				@mouseenter="onPointerMouseEnter($event)"
				@mouseleave="onPointerMouseLeave($event)"
			>
				<IconCircle :fill="current === i ? fill : 'none'" :stroke="current === i ? fill : '#000'" />
			</li>
		</ul>

		<div class="description">
			<transition-group name="desc">
				<div v-for="(image, i) in images" :key="`desc_${i}`" v-show="i === current">{{ image.caption }}</div>
			</transition-group>
		</div>
		<!-- <textarea v-html="JSON.stringify(exampleObject)"></textarea> -->
	</section>
</template>

<script>
import IconCircle from "@/components/icons/IconCircle";
import EventBus from "@/helpers/event-bus";

export default {
	components: {
		IconCircle,
	},
	props: {
		images: Array,
	},
	computed: {
		pathHeight() {
			return 0.5744485294 * this.pathWidth;
		},
	},
	data() {
		return {
			pathWidth: 1088,
			path: [
				{ vector: "M", values: [0.9586397058823529, 0.856] },
				{ vector: "C", values: [0.8835214632352941, 1.0331679792000001, 0.71875, 0.9952, 0.4898897058823529, 0.9952] },
				{
					vector: "C",
					values: [0.3428308823529412, 0.9952, 0.08541615119485294, 0.9952281824, 0.03768382352941176, 0.8912],
				},
				{
					vector: "C",
					values: [
						-0.02022058823529412,
						0.765002704,
						-0.011955061580882352,
						0.2335967584,
						0.058823529411764705,
						0.0912,
					],
				},
				{ vector: "C", values: [0.11210750183823529, -0.016, 0.3781535165441176, 0.0032, 0.5165441176470589, 0.0032] },
				{
					vector: "C",
					values: [0.7022058823529411, 0.0032, 0.87473265625, -0.013466815376, 0.9329044117647058, 0.072],
				},
				{ vector: "C", values: [1.0170763143382353, 0.195666616, 1.015625, 0.721598968, 0.9586397058823529, 0.856] },
			],
			path3: [
				{ vector: "M", values: [0.9586397058823529, 0.856] },
				{ vector: "C", values: [0.8835214632352941, 1.1331679792000001, 0.71875, 0.9952, 0.4898897058823529, 0.9952] },
				{
					vector: "C",
					values: [0.3428308823529412, 0.9952, 0.08541615119485294, 0.9952281824, 0.03768382352941176, 0.8912],
				},
				{
					vector: "C",
					values: [
						-0.02022058823529412,
						0.765002704,
						-0.011955061580882352,
						0.2335967584,
						0.058823529411764705,
						0.0912,
					],
				},
				{ vector: "C", values: [0.11210750183823529, -0.016, 0.3781535165441176, 0.0032, 0.5165441176470589, 0.0032] },
				{
					vector: "C",
					values: [0.7022058823529411, 0.0032, 0.87473265625, -0.013466815376, 0.9329044117647058, 0.072],
				},
				{ vector: "C", values: [1.0170763143382353, 0.195666616, 1.015625, 0.721598968, 0.9586397058823529, 0.856] },
			],
			path4: [
				{ vector: "M", values: [0.9586397058823529, 0.856] },
				{ vector: "C", values: [0.8835214632352941, 1.0331679792000001, 0.71875, 0.9952, 0.4898897058823529, 0.9952] },
				{
					vector: "C",
					values: [0.3428308823529412, 0.9952, 0.08541615119485294, 0.9952281824, 0.03768382352941176, 0.8912],
				},
				{
					vector: "C",
					values: [
						-0.02022058823529412,
						0.765002704,
						-0.011955061580882352,
						0.2335967584,
						0.058823529411764705,
						0.0912,
					],
				},
				{ vector: "C", values: [0.10291632536764705, -0.032, 0.3781535165441176, 0.0352, 0.5165441176470589, 0.0352] },
				{
					vector: "C",
					values: [0.7022058823529411, 0.0352, 0.87473265625, -0.03586681536, 0.9329044117647058, 0.0496],
				},
				{
					vector: "C",
					values: [1.0170763143382353, 0.173266616, 1.0091911764705883, 0.743998968, 0.9522058823529411, 0.8784],
				},
			],
			path2: [
				{ vector: "M", values: [0.9522058823529411, 0.8784] },
				{ vector: "C", values: [0.8770876397058823, 1.0555679792000001, 0.71875, 0.9472, 0.4898897058823529, 0.9472] },
				{
					vector: "C",
					values: [0.3428308823529412, 0.9472, 0.10379850367647059, 1.0272281824, 0.05606617647058824, 0.9232],
				},
				{
					vector: "C",
					values: [-0.001838235294117647, 0.797002704, -0.02114623805147059, 0.2175967584, 0.04963235294117647, 0.0752],
				},
				{ vector: "C", values: [0.10291632536764705, -0.032, 0.3781535165441176, 0.0352, 0.5165441176470589, 0.0352] },
				{
					vector: "C",
					values: [0.7022058823529411, 0.0352, 0.87473265625, -0.03586681536, 0.9329044117647058, 0.0496],
				},
				{
					vector: "C",
					values: [1.0170763143382353, 0.173266616, 1.0091911764705883, 0.743998968, 0.9522058823529411, 0.8784],
				},
			],
			d: "",
			d2: "",
			current: 0,
			fill: "#FF3D37",
			exampleObject: [],
		};
	},
	created() {
		window.addEventListener("resize", this.onResize);
	},
	mounted() {
		setTimeout(() => {
			this.onResize();
		}, 501);

		// const d = "1043,535 C961.271352,645.729987 782,622 533,622 C373,622 92.9327725,622.017614 41,557 C-22,478.12669 -13.007107,145.997974 64,57 C121.972962,-10 411.431026,2 562,2 C764,2 951.70913,-8.41675961 1015,45 C1106.57903,122.291635 1105,450.999355 1043,535"
		const d =
			"1036,549 C954.271352,659.729987 782,592 533,592 C373,592 112.932772,642.017614 61,577 C-2,498.12669 -23.007107,135.997974 54,47 C111.972962,-20 411.431026,22 562,22 C764,22 951.70913,-22.4167596 1015,31 C1106.57903,108.291635 1098,464.999355 1036,549";
		const arr = d.split(/[ ][A-Z]/);
		const arr2 = arr.map((v) => v.split(/[ ,]/));
		// console.log(arr2);
		const arrPercent = arr2.map((v) =>
			v.map((val, n) => {
				const divider = n % 2 === 0 ? 1088 : 625;
				return +val / divider;
			})
		);

		// const arrPercent2 = arrPercent.map(v => v.reduce((acc, cur, idx) => {
		// 	return acc += idx % 2 === 0 ? `${cur},` : `${cur} `
		// },''))

		const obj = [];

		arrPercent.forEach((v, i) => {
			obj.push({
				vector: i === 0 ? "M" : "C",
				values: v,
			});
		});

		this.exampleObject = obj;

		// console.log(obj);
	},
	methods: {
		onPointerMouseEnter(ev, type = "default") {
			const parent = ev.currentTarget.getElementsByTagName("path")[0];
			EventBus.$emit(EventBus.pointer.enter, { el: parent, type, parent });
		},
		onPointerMouseLeave(ev, type = "default") {
			const parent = ev.currentTarget.getElementsByTagName("path")[0];
			EventBus.$emit(EventBus.pointer.leave, { el: parent, type, parent });
		},
		onResize() {
			this.pathWidth = this.$refs.images.clientWidth;
			this.d = this.getDPath(this.path);
			this.d2 = this.getDPath(this.path2);
		},
		setSlide(i) {
			this.current = i;
		},
		getDPath(path) {
			const helper = path.map((v) =>
				v.values.reduce((acc, cur, idx) => {
					return (acc +=
						// idx % 2 === 0 ? `${Math.round(cur * this.pathWidth)},` : `${Math.round(cur * this.pathHeight)} `);
						idx % 2 === 0 ? `${cur * this.pathWidth},` : `${cur * this.pathHeight} `);
				}, v.vector)
			);

			const retPath = helper.reduce((acc, cur) => (acc += cur));

			return `${retPath} Z`;
		},
		swipeHandler(d) {
			const { direction } = d;
			if (direction === 2) {
				this.current = this.current < this.images.length - 1 ? this.current + 1 : 0;
			}

			if (direction === 4) {
				this.current = this.current > 0 ? this.current - 1 : this.images.length - 1;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@keyframes moveImage {
	0% {
		transform: scale(1);
	}

	50% {
		transform: scale(1.2);
	}

	100% {
		transform: scale(1);
	}
}
.images {
	@include gridColumn(s, 10, 1, false, true);
	position: relative;
	margin-top: 60px;
	// clip-path: url(#my-shape);

	@include mq($from: m) {
		@include gridColumn(m, 22, 1, false, true);
		margin-top: 100px;
	}

	@include mq($from: xl) {
		@include gridColumn(xl, 18, 3, false, true);
		margin-top: 120px;
	}

	&:after {
		display: block;
		content: "";
		width: 100%;
		padding-bottom: 56.25%;
	}

	svg,
	img {
		position: absolute;
		top: -5%;
		left: -5%;
		width: 110%;
		height: 110%;
		object-fit: cover;
		pointer-events: none;
		// animation: moveImage 120s;
	}
}

.description {
	@include fontCopyS;
	position: relative;
	text-align: center;
	width: 100%;

	@include mq($from: xl) {
		// @include gridColumn(xl, 8, 8, false, false);
		margin-top: 10px;
	}

	& * {
		@include fontCopyS;
	}
}

.nav {
	margin: 0;
	list-style: none;
	display: flex;
	width: 100%;
	justify-content: center;
	transform: translateY(-30%);

	li {
		padding: 6px;
		cursor: pointer;
		width: 26px;

		svg {
			width: 100%;
		}
	}
}

.list-enter-active,
.list-leave-active {
	transition: all 1s;
	z-index: 2;
}
.list-enter-active {
	z-index: 3;
}

.list-enter {
	opacity: 0;
}

.list-leave-to /* .list-leave-active below version 2.1.8 */ {
	opacity: 0;
}

.desc-enter-active,
.desc-leave-active {
	transition: all 1s;
}

.desc-leave-active {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	// transform: translateX(-50%);
}

.desc-enter-active {
	z-index: 3;
}

.desc-enter {
	opacity: 0;
}

.desc-leave-to /* .desc-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>
